import { ChangeDetectorRef, Component, Input, Sanitizer, ViewChild } from '@angular/core';
import { AgentService } from '../agent-builder-services/agent.services';
import { NzMessageService } from 'ng-zorro-antd/message';
import { LanguageServices } from 'src/app/services/LanguageServices';
import { Agent } from '../agent-builder-services/agent.service';
import { map, Observable, Subscription } from 'rxjs';
import { Answer, IAConversation, IAConverse, IAServices } from 'src/app/webhook-creator/webhook-creator/webhook-services/IAServices';
import { GlobalErrorHandler } from 'src/app/services/GloabalErrorHandler.services';
import { UserAuthenticationServices } from 'src/app/services/user-authentication.services';
import { DomSanitizer } from '@angular/platform-browser';
import { StringUtils } from 'src/app/system-utils/utils/StringUtils';
import { NzUploadChangeParam, NzUploadFile, NzUploadXHRArgs } from 'ng-zorro-antd/upload';
import { UploadServices } from 'src/app/services/upload.services';
import { HttpEventType } from '@angular/common/http';
import { KnowledgeBase, KnowledgeBaseService } from '../agent-builder-services/knowledge-base.service';
import { NzTableComponent } from 'ng-zorro-antd/table';


@Component({
  selector: 'agent-builder-prompt',
  templateUrl: './agent-builder-prompt.component.html',
  styleUrls: ['./agent-builder-prompt.component.scss'],
  standalone: false
  
})
export class AgentBuilderPromptComponent {

    agentName = '';
    userPrompt = '';
    response = '';
    feedback = '';
    fileList: NzUploadFile[] = [];
    loading = false;
    initLoading = false;
    @Input()agent:Agent;
    converse: Observable<IAConversation[]>;
    sessionId:string = null;
    sub2:Subscription;
    loadingAttach:boolean = false;
    loadingFeedback:boolean = false;
    correlationId:string[] = [];
    subProgress:Subscription;
    uploadSubs:Subscription;
    showModalContext = false;
    variables:any[] = [];
    cacheName:string;
    showModalFeedback = false;
    iaSub:Subscription;
    @ViewChild('tableContextVariable') tableContextVariable: NzTableComponent<any>;


    closeModalFeedback(){
        this.showModalFeedback = true;
    }


    newKeyVariable:any = null;
    newValueVariable:any = null;

    addVariable(){
        this.variables=[
            ...this.variables, {
            key:this.newKeyVariable,
            value:this.newValueVariable
        }];

        this.newKeyVariable = null;
        this.newValueVariable = null;
        localStorage.setItem(this.cacheName, JSON.stringify(this.variables));
    }

    removeVariable(i){
        this.variables.splice(i,1);
        this.tableContextVariable.data = [...this.variables];
        if ( this.variables.length == 0){
            localStorage.removeItem(this.cacheName);
        }else{
            localStorage.setItem(this.cacheName, JSON.stringify(this.variables));
        }
        
    }


    get messages(): Observable<IAConverse[]> {
      return this.converse.pipe(
          map((converseList: IAConversation[]) => {
              const conv = converseList.find(d => d.sessionId === this.sessionId && d.agent === this.agent._id);
              return conv?.messages ?? [];
              })
          );
    }

    constructor(
        private iaService:IAServices,
        private cd:ChangeDetectorRef,
        private uas:UserAuthenticationServices,
        public sanitizer:DomSanitizer,
        private message:NzMessageService,
        private ls:LanguageServices,
        private updLoad:UploadServices,
        private ks:KnowledgeBaseService,

    ) {
        this.converse = iaService.converse$;
    }

    onChangeFileList(event: NzUploadChangeParam) {
        
        if (event.type === 'success' && event.file?.['originFileObj']['correlationId']) {
            const backendId = event.file?.['originFileObj']['correlationId'];
            
            this.fileList = event.fileList.map(f => {
            if (f.uid === event.file.uid) {
                return {
                ...f,
                name: `${f.name} - ${backendId}` // aqui muda o que o DOM enxerga
                };
            }
            return f;
            });

        }

        if ( event.type == "removed"){
            let id = event.file?.['originFileObj']['correlationId'];

            if (id !=null ){
                let index = this.correlationId.findIndex(d=>d == id);
                this.correlationId.splice(index,1);
            }
        }

    }

    ngOnDestroy(): void {   
    
        if ( this.sub2 ) {
            this.sub2.unsubscribe();
        }

        if ( this.iaSub ) {
            this.iaSub.unsubscribe();
        }
    }

    beforeUpload = (file: File): boolean => {
        return true;
    };

    scrollToBottom(): void {
        const scrollContainer = document.querySelector('.ia-response');
        if (scrollContainer) {
            scrollContainer.scrollTo({ top: scrollContainer.scrollHeight, behavior: 'smooth' });
        } else {
            // Se não há container de rolagem, rola para o final do canvas
            const canvas = document.querySelector('.ia-response');
            if (canvas) {
                canvas.scrollIntoView({ behavior: 'smooth', block: 'end' });
            }
        }
    }

    fullBuffer: string = '';     // texto REAL vindo do SSE
    displayText: string = '';    // texto que aparece na tela
    typingTimer: any = null;
    typingIndex: number = 0;  

    startTyping(sessionId: string, agentId: string) {
        if (this.typingTimer) return;

        this.typingTimer = setInterval(() => {

            // se já digitou tudo que existe no buffer, espera novos tokens
            if (this.typingIndex >= this.fullBuffer.length) return;

            // pega o próximo caractere correto
            const nextChar = this.fullBuffer[this.typingIndex];
            this.typingIndex++;

            this.displayText += nextChar;

            this.iaService.updateConverseStream(sessionId, agentId, {
                role: 'assistant',
                text: this.displayText,

            });

            this.cd.detectChanges();
            this.scrollToBottom();

        }, 30); // velocidade da digitação

    }


    converseWithAI(prompt) {
            
        this.messages.subscribe(messages => {
            const firstQuestion = !messages || messages.length === 1;
            prompt = this.mountPrompt(prompt, firstQuestion)
        });
        
        this.scrollToBottom();
        this.iaService.updateConverse( this.sessionId, this.agent._id, { text: this.userPrompt, role: 'user' });
        
        if ( this.agent.stream ){
            this.fullBuffer = '';
            this.displayText = '';
            this.typingIndex = 0;

            if (this.typingTimer) {
                clearInterval(this.typingTimer);
                this.typingTimer = null;
            }



            this.iaSub = this.iaService.sendPromptToAiStream(
                this.sessionId,
                this.agent._id,
                prompt,
                this.correlationId,
                this.variables).subscribe({
                    next: evt => {
                        if (evt.event === "token") {
                            this.fullBuffer += evt.data;
                            this.startTyping(this.sessionId, this.agent._id);
                            this.loading = false;
                        }


                        if (evt.event === "finish") {

                            let response = JSON.parse(JSON.stringify(evt.data));
                            const finalText = response.answer;
                            this.fullBuffer = finalText;

                            const stopCheck = setInterval(() => {
                                if (this.typingIndex >= this.fullBuffer.length) {

                                    clearInterval(this.typingTimer);
                                    this.typingTimer = null;
                                    clearInterval(stopCheck);

                                    this.iaService.updateConverseStream(
                                        this.sessionId,
                                        this.agent._id,
                                        {
                                            text: finalText,
                                            role: 'assistant',
                                            chunkId: response.citations,
                                            converseId: response.converseId,
                                            action: null,
                                            lastprompt: prompt,
                                        }
                                    );
                                }
                            }, 100);

                                                   
                        }
                    },
                    complete: () => {
                        console.log("stream finalizado");
                    },
                    error: (error)=>{
                        this.loading = false;
                        GlobalErrorHandler.showError(error);
                    }
                });
        }else{
            this.iaService.sendPromptToAi(this.sessionId, this.agent._id, prompt, this.correlationId, this.variables).then((response:Answer) => {
                    
            let responseTreat = response.answer;

            this.iaService.updateConverse(this.sessionId, this.agent._id,
                { text: responseTreat, role: 'assistant', chunkId: response.citations, converseId: response.converseId, action: null, lastprompt: prompt});

            
            this.loading = false;
            this.cd.detectChanges();
            this.scrollToBottom();

            }).catch(error=>{
                    this.loading = false;
                    GlobalErrorHandler.showError(error);
            }).finally(()=>{
                this.cd.detectChanges();
            });
        }

        
    }


    mountPrompt(prompt: any, firstQuestion: boolean): any {
        let newPrompt = '';

        if ( firstQuestion ){
            newPrompt += 'Oi, meu nome é ' + this.uas.user.username + '\n';
            newPrompt += 'Aqui está o meu primeiro prompt: ' + prompt;
        }else{
            newPrompt += prompt;
        }
        return newPrompt;
    }
    
    enviarPrompt() {

        if (!this.userPrompt || this.loading || this.initLoading || this.loadingAttach){
            return
        }

        this.loading = true;
        
        this.converseWithAI(this.userPrompt);
        this.userPrompt = '';
        
        setTimeout(()=>this.scrollToBottom(),100);
            
    }

    onOKFeedBack(resposta: IAConverse){
        this.loadingFeedback = true;
        this.iaService.sendFeedBack(this.agent, resposta, this.sessionId).then(data=>{
            resposta.feedbackId = data['_id'];
            this.showModalFeedback = false;
            this.loadingFeedback = false;
            this.message.success(this.ls.instant('agentBuilder.feedbackSuccess'));
        }).catch(error=>{
            this.loadingFeedback = false;
            this.message.error(this.ls.instant('agentBuilder.feedbackError')+ " : " +GlobalErrorHandler.getMessage(error));
        });  
    }

    onCancelFeedback(resposta: IAConverse){
        resposta.feedback = '';
        resposta.feedbackMessage = null;
        this.showModalFeedback = false;
        
    }
    
    sendFeedback(resposta: IAConverse, negative: boolean) {
        
            if ( resposta.feedbackId){
                this.message.error(this.ls.instant('agentBuilder.alreadyWithFeedback'));
                return;
            }

            resposta.feedback = negative? 'down' : 'up';
            if ( negative ){
                this.showModalFeedback = true;
            }else{
                this.loadingFeedback = true;
                this.iaService.sendFeedBack(this.agent, resposta, this.sessionId).then(data=>{
                    resposta.feedbackId = data['_id'];
                    this.loadingFeedback = false;
                    this.showModalFeedback = false;
                    this.message.success(this.ls.instant('agentBuilder.feedbackSuccess'));
                }).catch(error=>{
                    this.loadingFeedback = false;
                    this.message.error(this.ls.instant('agentBuilder.feedbackError')+ " : " +GlobalErrorHandler.getMessage(error));
                });  
            }
    }
    

    ngOnInit(): void {

        this.sessionId = StringUtils.UIDGerador();
        this.isSessionInitialized();

        this.cacheName = "ia_variable_context_"+this.agent._id;

        let cacheVariables = localStorage.getItem(this.cacheName);
        if ( cacheVariables!= null ){
            try{
                this.variables = JSON.parse(localStorage.getItem(this.cacheName)) as any[];
            }catch(Exception){
                localStorage.removeItem(this.cacheName);
            }
            
        }

        setTimeout(()=>this.scrollToBottom(),100);
    }

    newSession(){
        this.sessionId = StringUtils.UIDGerador();
        this.isSessionInitialized();
        
        this.iaService.stopConverse();
        if ( this.subProgress != null ){
            this.subProgress.unsubscribe();
    
        }
        if ( this.uploadSubs != null){
            this.uploadSubs.unsubscribe();
        }
        this.correlationId = [];
        this.fileList = [];
        this.loading = false;
        this.initLoading = false;
        this.loadingAttach =false;
    }
    
    isSessionInitialized() {
        this.converse.subscribe((converseList:IAConversation[])=> { 
            const conv = converseList.find(d => d.sessionId === this.sessionId && d.agent === this.agent._id);
            if ( conv == null ){
                this.initLoading = true;
                    this.iaService.updateConverse(this.sessionId, this.agent._id,
                    { text: (this.agent.welcomeMessage as string), role: 'assistant', welcomeMessage:true });
                this.initLoading = false;
                
            }
        });
    }

    clickAttach(event){
        console.log(event);
    }
    
    

    customUpload = (item: NzUploadXHRArgs) => {
    
        if (!this.agent._id) {
            this.message.error(this.ls.instant('agentBuilder.prompt_save_agent_before'));
        return;
        }

        const formData = new FormData();
        formData.append('file', item.file as any);
        
        this.subProgress = this.updLoad.progress.subscribe(value => {
            const percent = Number(value) || 0;

            const progressEvent: any = {
                type: HttpEventType.UploadProgress,
                loaded: percent,
                total: 101,
                percent
            };

            try {
                item.onProgress?.(progressEvent, item.file!);
            } catch {
                
            }
        });
        this.loadingAttach = true;
        this.uploadSubs = this.updLoad.upLoadFileFlex(formData, "AiServices/injest/uploadfile", true).subscribe({
            next:async(event) => {  
                
                if (event instanceof Object && !Array.isArray(event) && event.hasOwnProperty('path')) {
                    let ob = event;
                    let kb:KnowledgeBase = {
                        filePath: ob.path,
                        fileName: ob.fileName,
                        fileSize: ob.fileSize,
                        mimeType: ob.mimeType
                    }
                    
                    await this.ks.updateDocumentationBase(this.agent, kb).then(
                        (data) => {
                            if ( data!= null && data['correlationId']!=null ){
                                this.correlationId.push(data['correlationId']);
                                kb.id = data['correlationId'];
                                item.file.filename  = item.name +  " --- " + kb.id;
                                item.file['correlationId'] = kb.id;
                            }
                            

                                // // atualiza a lista (importante para change detection)
                                

                            this.message.success(this.ls.instant('agentBuilder.attached_file_success'));
                            this.loadingAttach = false;
                            const percent = 101;
                            item.onSuccess?.({percent:percent}, item.file!, null as any);
                            this.subProgress.unsubscribe();
                        },
                        (error) => {
                            let message = GlobalErrorHandler.getMessage(error) || this.ls.instant('agentBuilder.attached_file_error');
                            this.message.error(message);
                            this.loadingAttach = false;
                            const msg = message;
                            item.file!.status = 'error';
                            item.file!.error = msg;
                            item.file!.response = error.error;
                            item.onError!(msg, item.file!);


                            
                        }
                    );             
                    
                }
            },
            error: (error) => {
                item.onError?.(error, item.file!);
                this.loadingAttach = false;
                this.subProgress.unsubscribe();
            },
            complete: () => {
                this.subProgress.unsubscribe();
            }
        });
    };

    openContext(){
        this.showModalContext = true;
    }

    closeContext(){
        this.showModalContext = false;
    }
}